<template>
	<div class="app">
		<!-- Income access affiliate tracker -->
		<iframe
			style="display: none"
			id="incomeaccess"
			v-if="show_income_access"
			:src="`http://wlbetika.adsrv.eacdn.com/Processing/Pixels/Registration.ashx?PlayerID=${user.id}`"
		></iframe>
		<component :is="$store.getters.layout" v-if="$store.getters.sportsLoaded" />
		<div id="app" v-else>
			<div class="app-loader">
				<img :src="`${env.logoUrl}`" width="100px" />
				<div class="app-loader-animation"></div>
			</div>
		</div>
		<!-- Portal targets -->
		<portal-target name="bottom-sheet" />
		<portal-target name="modal" />
		<portal-target name="modal-two" />
		<portal-target name="fullscreen" />
	</div>
</template>

<script>
import store from "../store";
import parser from "../assets/scripts/ua-parser.min.js";
import Mobile from "../layouts/Mobile.vue";
import Desktop from "../layouts/Desktop.vue";

export default {
	name: "app",
	components: { Mobile, Desktop },
	data() {
		return {
			online: window.navigator.onLine,
			liveMatches: [],
			matchesInBetslip: [],
			btag: null,
			affiliateData: null,
			affiliateMatchData: null,
			affiliateMatchMeta: null,
			show_income_access: false,
		};
	},
	mounted() {
		this.init();
	},
	watch: {
		loggedIn() {
			var vm = this;
			return JSON.parse(window.localStorage.getItem("authenticated"));
		},
		$route(to, from) {
			var vm = this;
			if (window.location.hash.indexOf("live") < 0) {
				window.clearInterval(window.localStorage.getItem("liveUpdateID"));
				window.clearInterval(window.localStorage.getItem("liveMatchUpdateID"));
			}
		},
		online() {
			if (!this.online) {
				this.$notifications.add({
					message:
						"You are offline. Please refresh your matches once you get back online",
					title: "Offline ",
					type: "error",
					duration: 5000,
				});
			}
			if (this.online) {
				this.$notifications.add({
					message: "You are back online. Please refresh your matches",
					title: "Online",
					type: "success",
					duration: 5000,
				});
			}
		},
	},
	computed: {
		isLoggedIn() {
			return JSON.parse(window.localStorage.getItem("authenticated"));
		},
		user: {
			get() {
				return this.$store.getters.user;
			},
			set(u) {
				this.$store.commit("setUser", u);
			},
		},

		amount() {
			return this.$store.getters.stake;
		},
	},
	methods: {
		getCompetitionFromUrl() {
			let competitionName = this.$route.params.competitionName;
			if (!competitionName)
				return {
					competition_id: null,
					competition_name: null,
				};
			let selectedCountry = this.$store.getters.countries.data.find(
				(country) => {
					return country.competitions.find((competition) => {
						return competition.urlSlug === competitionName;
					});
				}
			);
			let selectedCompetition = selectedCountry.competitions.find(
				(competition) => {
					return competition.urlSlug === competitionName;
				}
			);

			return selectedCompetition;
		},
		getSportFromUrl() {
			let sportName = this.$route.params.sportName;
			if (!sportName) return this.env.defaultSport;
			let selectedSport = this.$store.getters.sports.find((sport) => {
				return sport.sport_name.split(" ").join("-").toLowerCase() == sportName;
			});
			return selectedSport;
		},
		async init() {
			let vm = this;
			vm.$store.dispatch("getSports").then((sports) => {
				vm.$store.commit("SET_SPORTS", sports);
			});
			vm.handleDeeplink();
			window.showIncomeAccess = this.showIncomeAccess;
			window.forcePlaceBet = this.forcePlaceBet;
			vm.$store.commit("dataNotifier/setIsSaf");
			vm.$store.commit("cashout/initSettingsFromAPI");
			let utm_source = this.$utils.getParameterByName("utm_source");
			let utm_medium = this.$utils.getParameterByName("utm_medium");
			if (utm_source) {
				if (utm_medium) utm_source += `/${utm_medium}`;
				sessionStorage.setItem("affiliate", `${utm_source}`);
				localStorage.setItem("utm_source", utm_source);
			}
			if (this.$utils.getParameterByName("affiliate_id")) {
				sessionStorage.setItem(
					"affiliate",
					this.$utils.getParameterByName("affiliate_id")
				);
			}
			if (this.$utils.getParameterByName("affiliate")) {
				sessionStorage.setItem(
					"affiliate",
					this.$utils.getParameterByName("affiliate")
				);
			}
			if (this.$utils.getParameterByName("btag")) {
				localStorage.setItem("btag", this.$utils.getParameterByName("btag"));
			}
			// Save token as a cookie
			// if (this.$utils.getParameterByName("token")) {
			// 	let token = this.$utils.getParameterByName("token");
			// 	if(token.isMatch("^[A-Za-z0-9_\-]{32}$")){
			// 		vm.$cookie.set("aff_token", token, 1);
			// 	}
			// }
			const operaId = vm.getParameterByName("gaid");
			if (vm.isLoggedIn) {
				vm.$store.dispatch("freebets/getFreebets");
			}
			if (operaId) {
				vm.$store.dispatch("trackOperaId", operaId);
				vm.$cookie.set("gaid", operaId, 365);
				vm.$store.commit("addToAuthActions", () => {
					vm.$store.dispatch("trackOperaId", operaId);
				});
			}
			vm.$store.commit("addToAuthActions", () => {
				vm.$tracking.getUserInfo();
				vm.$store.commit("cashout/initSettingsFromAPI");
			});

			vm.$store.dispatch("getLegal");

			// User Agent
			const _parser = new parser();
			let ua = _parser.getResult();

			localStorage.user_agent = JSON.stringify(ua);

			window.addEventListener("focus", () => {
				console.log("Window has focus");
				vm.$store.commit("dataNotifier/setIsSaf");
			});
			// Network status event listener
			window.addEventListener("online", () => {
				vm.online = true;
				vm.$store.commit("dataNotifier/setIsSaf");
			});

			window.addEventListener("offline", () => {
				vm.online = false;
			});

			vm.handleResize();
			window.addEventListener("resize", vm.handleResize);
		},
		handleResize() {
			const DESKTOP_WIDTH = 1024;
			this.$store.commit(
				"CHANGE_LAYOUT",
				window.innerWidth < DESKTOP_WIDTH ? "Mobile" : "Desktop"
			);
		},
		forcePlaceBet() {
			let vm = this;
			return new Promise((resolve, reject) => {
				vm.acceptOddChanges();
				vm.removeInvalidMatches();
				let now = new Date();
				if (
					vm.$store.getters.betSlip.find((bet) => {
						return bet.live;
					})
				) {
					if (
						now.getUTCHours() > 22 &&
						now.getUTCHours() < 5 &&
						vm.amount > 500000
					) {
						reject(
							"Maximum live bets amount is " +
								vm.$options.filters.currency(MAXIMUM_LIVE_BETS_AMOUNT)
						);
						return vm.$notifications.add({
							message:
								"Maximum live bets amount is " +
								vm.$options.filters.currency(MAXIMUM_LIVE_BETS_AMOUNT),
							title: "Bet limit warning",
							type: "warning",
							duration: 5000,
						});
					}
					if (
						now.getUTCHours() > 5 &&
						now.getUTCHours() < 22 &&
						vm.amount > 500000
					) {
						reject(
							"Maximum live bets amount is " +
								vm.$options.filters.currency(MAXIMUM_LIVE_BETS_AMOUNT)
						);
						return vm.$notifications.add({
							message:
								"Maximum live bets amount is " +
								vm.$options.filters.currency(MAXIMUM_LIVE_BETS_AMOUNT),
							title: "Bet limit warning",
							type: "warning",
							duration: 5000,
						});
					}
				}

				// Check whether the user is authenticated
				if (!JSON.parse(window.localStorage.getItem("authenticated"))) {
					vm.$notifications.add({
						message: "Please login to place a bet",
						title: "Authentication required",
						type: "warning",
						duration: 3000,
					});
					vm.$router.push("/login?next=" + vm.$route.fullPath);
					reject("Not authenticated");
					return;
				}

				// Check whether amount > 50
				if (vm.amount < 1) {
					vm.$notifications.add({
						message:
							"Minimum bet amount is " +
							vm.$options.filters.currency(MINIMUM_SPORTSBOOK_BET_AMOUNT),
						title: "Bet limit warning",
						type: "warning",
						duration: 3000,
					});
					reject(
						"Minimum bet amount is " +
							vm.$options.filters.currency(MINIMUM_SPORTSBOOK_BET_AMOUNT)
					);
					return;
				}

				// Get balances before placing the bet
				const wallet_balance_before = vm.$store.getters.user.balance;
				const wallet_bonus_before = vm.$store.getters.user.bonus;

				// Map betslip to endpoint requirements
				let betslip = vm.$store.getters.betSlip.map((bet) => {
					return {
						sub_type_id: bet.type,
						bet_pick: bet.odd.odd_key,
						odd_value: bet.odd.odd_value,
						outcome_id: bet.odd.outcome_id,
						sport_id: bet.odd.sport_id,
						special_bet_value: bet.odd.special_bet_value
							? bet.odd.special_bet_value
							: "",
						parent_match_id: bet.odd.parent_match_id,
						bet_type: bet.live ? 8 : 7,
					};
				});

				let oddValues = vm.$store.getters.betSlip.map((bet) => {
					return Number(bet.odd.odd_value);
				});

				let totalOdds = oddValues.reduce((a, b) => a * b, 1);

				// Build payload
				let payload = {
					profile_id: window.localStorage.getItem("user")
						? JSON.parse(window.localStorage.getItem("user")).id
						: "",
					stake: vm.amount.toString(),
					total_odd: totalOdds.toString(),
					src: "MOBILE_WEB",
					betslip: betslip,
					token: window.localStorage.getItem("token")
						? JSON.parse(window.localStorage.getItem("token"))
						: "",
					user_agent: localStorage.user_agent ? localStorage.user_agent : null,
					affiliate: localStorage.affiliate ? localStorage.affiliate : null,
				};

				if (vm.$cookie.get("btag")) {
					payload.affiliate_id = 19;
					payload.affiliate_tag = vm.$cookie.get("btag");
				}
				let liveMatches =
					vm.$store.getters.betSlip.findIndex((b) => b.live) > -1;

				const url = `${BASE_V2_URL}bet`;
				// Server request
				let delay = 0;
				setTimeout(() => {
					vm.$axios
						.post(url, payload)
						.then((response) => {
							vm.$store.commit("clearBetslip");
							vm.$notifications.add({
								message: response.data.message,
								title: "Bet placement successful",
								type: "success",
								duration: 5000,
							});
							resolve(true);
						})
						.catch((error) => {
							if (error.response) {
								if (error.response.status == 401) {
									window.localStorage.setItem("authenticated", false);
									window.localStorage.removeItem("user");
									window.localStorage.removeItem("token");

									vm.$notifications.add({
										message: "Your session has expired. Please login again",
										title: "Session expired",
										type: "error",
										duration: 5000,
									});
									vm.$router.replace("/login?next=" + vm.$route.fullPath);
									return;
								} else {
									vm.$notifications.add({
										message: error.response.data.message,
										title: "Bet placement error",
										type: "error",
										duration: 5000,
									});
								}
							} else {
							}
							reject(error);
						});
				}, delay);
			});
		},
		removeInvalidMatches() {
			this.$store.commit("removeInvalidMatches");
		},
		acceptOddChanges() {
			this.$store.getters.betSlip.map((bet) => {
				return (bet.changed = false);
			});
		},
		toBetslip() {
			this.$router.push("/betslip");
		},
		showIncomeAccess() {
			this.show_income_access = true;
		},
		handleDeeplink() {
			let vm = this;
			let is_deeplink = utils.getParameterByName("action") == "instantbet";
			if (is_deeplink) {
				// Get params
				let params = {
					parent_match_id: utils.getParameterByName("parent_match_id"),
					sub_type_id: utils.getParameterByName("sub_type_id"),
					odd_key: utils.getParameterByName("odd_key"),
					odd_value: utils.getParameterByName("odd_value"),
					special_bet_value: utils.getParameterByName("special_bet_value"),
					stake: utils.getParameterByName("stake"),
				};
				vm.affiliateData = params;
				this.getAffiliateMatchDetails();
			}

			let is_deeplink_live =
				utils.getParameterByName("action") == "instantbetlive";
			if (is_deeplink_live) {
				// Get params
				let params = {
					parent_match_id: utils.getParameterByName("parent_match_id"),
					sub_type_id: utils.getParameterByName("sub_type_id"),
					odd_key: utils.getParameterByName("odd_key"),
					odd_value: utils.getParameterByName("odd_value"),
					special_bet_value: utils.getParameterByName("special_bet_value"),
					stake: utils.getParameterByName("stake"),
				};
				vm.affiliateData = params;
				this.getAffiliateLiveMatchDetails();
			}

			if (this.$route.query.action === "instantbet") {
				vm.affiliateData = this.$route.query;
				this.getAffiliateMatchDetails();
			}

			if (this.$route.query.action === "instantbetlive") {
				vm.affiliateData = this.$route.query;
				this.getAffiliateMatchDetails();
			}

			if (this.$route.query.btag) {
				this.btag = this.$route.query.btag || null;
				this.$cookie.set("btag", this.btag, 365);
			}
			if (utils.getParameterByName("btag")) {
				this.btag = utils.getParameterByName("btag") || null;
				this.$cookie.set("btag", this.btag, 365);
			}
		},
		getAffiliateMatchDetails() {
			let vm = this;
			vm.$axios
				.get(
					`${BASE_URL}/match?parent_match_id=${vm.affiliateData.parent_match_id}`
				)
				.then((response) => {
					vm.affiliateMatchData = response.data.data;
					vm.affiliateMatchMeta = response.data.meta;
					if (vm.affiliateMatchMeta == null) {
						vm.$notifications.add({
							message: "Match add unsuccessful, expired match",
							title: "Deeplink error",
							type: "error",
							duration: 5000,
						});

						return;
					}
					vm.addToBetslip();
				})
				.catch((error) => {
					console.error(error);
				});
		},

		getAffiliateLiveMatchDetails() {
			this.$axios
				.get(
					`${LIVE_URL}/match?parent_match_id=${this.affiliateData.parent_match_id}`
				)
				.then((response) => {
					//console.log(response);
					this.affiliateMatchData = response.data.data;
					this.affiliateMatchMeta = response.data.meta;
					if (this.affiliateMatchMeta == null) {
						vm.$notifications.add({
							message: "Match add unsuccessful, expired match",
							title: "Deeplink error",
							type: "error",
							duration: 5000,
						});
						return;
					}
					this.addToBetslip();
				})
				.catch((error) => {
					console.error(error);
				});
		},

		addToBetslip() {
			var vm = this;
			let subTypeIdFilter = vm.affiliateMatchData.filter(
				(x) => x.sub_type_id == vm.affiliateData.sub_type_id
			);
			if (subTypeIdFilter.length == 0) {
				vm.$notifications.add({
					message: "Match add unsuccessful, check the parameters",
					title: "Deeplink error",
					type: "error",
					duration: 5000,
				});
				return;
			}
			subTypeIdFilter = subTypeIdFilter[0];
			let oddsFilter = subTypeIdFilter.odds.filter(
				(x) =>
					x.odd_key == vm.affiliateData.odd_key &&
					(vm.affiliateData.special_bet_value == ""
						? x.special_bet_value == "" || x.special_bet_value == null
						: vm.affiliateData.special_bet_value == x.special_bet_value)
			);
			if (oddsFilter.length == 0) {
				vm.$notifications.add({
					message: "Match add unsuccessful, check the parameters",
					title: "Deeplink error",
					type: "error",
					duration: 5000,
				});
				return;
			}
			oddsFilter = oddsFilter[0];
			let odd = {
				display: oddsFilter.display,
				odd_key: oddsFilter.odd_key,
				odd_value: oddsFilter.odd_value,
				outcome_id: oddsFilter.outcome_id,
				special_bet_value: oddsFilter.special_bet_value || "",
				parent_match_id: vm.affiliateData.parent_match_id,
			};
			vm.odd = odd;
			let bet = {
				matchId: vm.affiliateMatchMeta.match_id,
				odd,
				type: vm.affiliateData.sub_type_id,
				market: subTypeIdFilter.name,
				display: `${vm.affiliateMatchMeta.home_team} vs ${vm.affiliateMatchMeta.away_team}`,
				startTime: vm.affiliateMatchMeta.start_time,
				live: false,
				active: true,

				// Coola payload
				parent_match_id: odd.parent_match_id,
				game_description: `${vm.affiliateMatchMeta.home_team} vs. ${vm.affiliateMatchMeta.away_team}`,
				bet_pick: odd.odd_key,
				sub_type_id: vm.affiliateData.sub_type_id,
				market_name: subTypeIdFilter.name,
				odd_key: odd.odd_key,
				odd_value: odd.odd_value,
				outcome_id: odd.outcome_id,
				special_bet_value: odd.specialBetValue || "",
				bet_type: "prebet",
				home_team: vm.affiliateMatchMeta.home_team,
				away_team: vm.affiliateMatchMeta.away_team,
				start_time: vm.affiliateMatchMeta.start_time,
				sport_id: vm.affiliateMatchMeta.sport_id,
			};
			if (
				this.$store.state.betSlip.find(function (bet) {
					return (
						bet.matchId == vm.affiliateMatchMeta.match_id && bet.odd == odd
					);
				})
			) {
				this.removeFromBetslip(bet);
				return;
			}

			// if my match has a selected odd, remove it
			if (
				this.$store.state.betSlip.find(function (bet) {
					return bet.matchId == vm.affiliateMatchMeta.match_id;
				})
			)
				this.removeFromBetslip(bet);

			/*
                      add me to betslip after confirming that i'm not already there
                      and removing my match if it already exists
                  */
			this.$store.commit("updateStake", parseFloat(vm.affiliateData.stake));
			this.$store.commit("addToBetslip", bet);

			this.$notifications.add({
				message: "Bet successfully added to betslip",
				title: "Deeplink success",
				type: "success",
				duration: 5000,
			});
			this.toBetslip();
		},
		removeFromBetslip(bet) {
			this.selected = "";
			var vm = this;
			this.$store.commit("removeFromBetslip", {
				matchId: bet.matchId,
				odd: bet.odd,
				type: bet.type,
				market: bet.market,
				display: bet.display,
				startTime: bet.startTime,
				live: bet.live,
				active: bet.active,
			});
		},

		getParameterByName(name, url) {
			url = window.location.href;
			name = name.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return "";
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		},
	},
};
</script>

<style lang="scss">
@import "../assets/styles/_globals.scss";
@import "../assets/styles/_utils.scss";
@import "../assets/styles/_components.scss";
@import "../assets/styles/notifications.scss";

.online {
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 99999;
	position: fixed;
	top: 0;
	width: 100%;
	font-size: var(--font-small);
	color: var(--white);
	.icon {
		fill: red;
	}
	p {
		padding: 10px;
	}
}

@keyframes bounce {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-5px);
	}
}
.banner {
	position: fixed;
	z-index: 2147483647;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	transition: opacity 0.3s ease;
	cursor: pointer;
	&__container {
		position: relative;
		width: 90vw;
		max-width: 768px;
		margin: 0 auto;
		top: 30%;
		cursor: default;
	}
	&__content {
		background-color: #fcd200;
		color: #2a3482;
		justify-content: center;
		align-items: center;
		border-radius: 5px;
		&__action {
			padding: 8px 30px;
			background-color: #2a3482;
			color: var(--white);
			text-decoration: underline;
			font-size: var(--font-large);
			font-style: italic;
			font-weight: var(--font-weight-normal);
			outline: none;
			border: none;
		}
		&__info {
			margin: 14px 0;
			font-size: var(--font-large);
			font-weight: var(--font-weight-normal);
		}
		&__title {
			font-size: var(--font-large);
			font-style: italic;
			font-weight: var(--font-weight-bold);
			margin: 12px 0;
		}
		&__wrapper {
			display: flex;
			flex-direction: column;
			padding: 40px 0;
			justify-content: center;
			align-items: center;
		}
	}
	&__close {
		position: absolute;
		height: 25px;
		width: 25px;
		border-radius: 50%;
		background: var(--white);
		color: #454545;
		font-size: 1rem;
		right: -12.5px;
		top: -12.5px;
		text-align: center;
		line-height: 25px;
		box-shadow: var(--shadow);
		cursor: pointer;
	}
	&__image {
		width: 100%;
	}

	&__message__container {
		position: absolute;
		top: 20px;
		left: 5%;
		width: 60%;
		display: flex;
		flex-direction: column;
	}
	&__message_title {
		color: #fef341;
		font-size: 1.4rem;
		font-weight: var(--font-weight-medium);
	}
	&__message_content {
		color: var(--white);
		font-size: 1.2rem;
		font-weight: var(--font-weight-medium);
		line-height: 1.4rem;
	}
}
</style>
